import cx from 'classnames'
import { useIntl } from 'react-intl'

import Typography from '../../../Typography/Typography'

import './ToggleButton.scss'

const renderLabel = (label, icon, iconAsLabel) => {
    if (iconAsLabel) {
        return (
            <img
                src={`images/button/toggle/${icon}.svg`}
                alt={`${icon}`}
                style={{ marginTop: icon === 'sodexo' ? '-12px' : 0 }}
            />
        )
    }

    return <Typography variant={'buttonPrimary'}>{label ?? ''}</Typography>
}

const ToggleButton = ({ id, disabled, labelId, icon, iconAsLabel, onClick, withBorderRadius, active }) => {
    const intl = useIntl()

    return (
        <button
            className={cx('toggle-btn', active && 'active', disabled && 'disabled', withBorderRadius && 'brdr-radius')}
            type={'checkbox'}
            disabled={disabled}
            onClick={onClick}
        >
            {renderLabel(
                labelId ? intl.formatMessage({ id: `buttons.toggle.label.${labelId}` }) : null,
                icon,
                iconAsLabel
            )}
        </button>
    )
}

export default ToggleButton
